import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'
import { BrandVoice } from 'common/interfaces/brandVoices'

import { getBrandVoices } from '../brandVoiceApi'
import { keys } from '../queryKeys/brandVoiceKeys'

const useGetBrandVoicesQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getBrandVoicesQuery = useQuery({
    queryKey: keys.list(accountId),
    queryFn: () => getBrandVoices({ accountId }),
    staleTime: 10 * 60 * 1000,
    refetchOnMount: 'always',
    meta: {
      errorMessage: 'Brand voices could not be loaded',
    },
  })

  return getBrandVoicesQuery
}

export default useGetBrandVoicesQuery
